// extracted by mini-css-extract-plugin
export var root = "blog-post-preview-list-module--root--MYf14";
export var headline = "blog-post-preview-list-module--headline--S8v-1";
export var grid = "blog-post-preview-list-module--grid--L7YZO";
export var browseMoreNav = "blog-post-preview-list-module--browseMoreNav--noyAI typography-module--small--KHf9L";